import apiCore from "@/api/api.common";
import { Cache } from 'axios-extensions';

const FIVE_MINUTES = 1000 * 60 * 5;
const CAPACITY = 100;
const movieCache = new Cache({ maxAge: FIVE_MINUTES, max: CAPACITY })
const dftOptions = { useCache: false };

const repo = {
    getVideos: getVideos,
    updateVideo: updateVideo,
    deleteVideo: deleteVideo,
    uploadVideo: uploadVideo,
    getMovies: getMovies,
    syncMovies: syncMovies
};

function applyOpts(options) {
    return Object.assign({ cache: movieCache }, options || dftOptions)
}

function getVideos(options) {
    return apiCore.get("/videos", applyOpts(options));
}

function getMovies(options) {
    return apiCore.get("/movies", applyOpts(options));
}

function syncMovies(options) {
    return apiCore.get("/movies/sync", applyOpts(options));
}

function deleteVideo(id) {
    return apiCore.delete(`/videos/${id}`);
}

function updateVideo(payload) {
    return apiCore.put(`/videos/${payload.id}`, payload);
}

function uploadVideo(payload) {
    console.log(payload)
    return apiCore.post(`/videos/import`, payload);
}

export default repo